import polygonalChartType from '@/domain/enums/polygonalCharts/polygonalChart';
import DuvalTriangle1 from '@/domain/components/installation/engineering/chromatography/polygonalChart/charts/DuvalTriangle1';
import DuvalTriangle4 from '@/domain/components/installation/engineering/chromatography/polygonalChart/charts/DuvalTriangle4';
import DuvalTriangle5 from '@/domain/components/installation/engineering/chromatography/polygonalChart/charts/DuvalTriangle5';
import DuvalPentagon1 from '@/domain/components/installation/engineering/chromatography/polygonalChart/charts/DuvalPentagon1';
import DuvalPentagon2 from '@/domain/components/installation/engineering/chromatography/polygonalChart/charts/DuvalPentagon2';
import GasRatioC2h2C2h4C2h4C2h6 from '@/domain/components/installation/engineering/chromatography/polygonalChart/charts/GasRatioC2h2C2h4C2h4C2h6';
import GasRatioC2h2C2h4Ch4H2 from '@/domain/components/installation/engineering/chromatography/polygonalChart/charts/GasRatioC2h2C2h4Ch4H2';

export default {
  [polygonalChartType.DUVAL_TRIANGLE_1]: DuvalTriangle1,
  [polygonalChartType.DUVAL_TRIANGLE_4]: DuvalTriangle4,
  [polygonalChartType.DUVAL_TRIANGLE_5]: DuvalTriangle5,
  [polygonalChartType.DUVAL_PENTAGON_1]: DuvalPentagon1,
  [polygonalChartType.DUVAL_PENTAGON_2]: DuvalPentagon2,
  [polygonalChartType.GASES_RATIO_C2H2_C2H4_C2H4_C2H6]: GasRatioC2h2C2h4C2h4C2h6,
  [polygonalChartType.GASES_RATIO_C2H2_C2H4_CH4_H2]: GasRatioC2h2C2h4Ch4H2,
};
